// src/components/ServerStats.js
import React, { useState, useEffect } from 'react';
import { getAllServersStats } from '../utils/serverDistribution';
import './ServerStats.css';

function ServerStats() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadStats();
    // تحديث كل 30 ثانية
    const interval = setInterval(loadStats, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      const data = await getAllServersStats();
      setStats(data);
      setError(null);
    } catch (err) {
      console.error('Error loading server stats:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading && stats.length === 0) {
    return <div className="server-stats-loading">جاري تحميل إحصائيات السيرفرات...</div>;
  }

  if (error) {
    return (
      <div className="server-stats-error">
        <p>خطأ في تحميل الإحصائيات: {error}</p>
        <button onClick={loadStats}>إعادة المحاولة</button>
      </div>
    );
  }

  return (
    <div className="server-stats-container">
      <div className="server-stats-header">
        <h2>📊 حالة السيرفرات</h2>
        <button onClick={loadStats} className="refresh-button">
          🔄 تحديث
        </button>
      </div>

      <div className="servers-grid">
        {stats.map((server) => (
          <div key={server.id} className={`server-card ${server.status.toLowerCase().replace(' ', '-')}`}>
            <div className="server-card-header">
              <h3>{server.name}</h3>
              <span className={`status-badge ${server.status === 'متاح' ? 'available' : server.status === 'شبه ممتلئ' ? 'warning' : 'full'}`}>
                {server.status}
              </span>
            </div>

            <div className="server-card-body">
              <div className="server-info">
                <span className="label">المعرف:</span>
                <span className="value">{server.id}</span>
              </div>

              <div className="server-info">
                <span className="label">الدومين:</span>
                <span className="value domain">{server.domain}</span>
              </div>

              <div className="server-metrics">
                <div className="metric">
                  <span className="metric-label">العملاء النشطين</span>
                  <span className="metric-value">{server.activeClients} / {server.maxClients}</span>
                </div>

                <div className="metric">
                  <span className="metric-label">الأماكن المتاحة</span>
                  <span className="metric-value available-slots">{server.availableSlots}</span>
                </div>
              </div>

              <div className="usage-bar">
                <div 
                  className="usage-fill" 
                  style={{ 
                    width: `${server.usagePercent}%`,
                    backgroundColor: server.usagePercent >= 90 ? '#dc3545' : 
                                   server.usagePercent >= 70 ? '#ffc107' : '#28a745'
                  }}
                />
              </div>
              <div className="usage-percent">{server.usagePercent}% مستخدم</div>
            </div>
          </div>
        ))}
      </div>

      <div className="server-stats-summary">
        <div className="summary-item">
          <span className="summary-label">إجمالي السيرفرات:</span>
          <span className="summary-value">{stats.length}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">إجمالي العملاء:</span>
          <span className="summary-value">{stats.reduce((sum, s) => sum + s.activeClients, 0)}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">السعة الإجمالية:</span>
          <span className="summary-value">{stats.reduce((sum, s) => sum + s.maxClients, 0)}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">الأماكن المتاحة:</span>
          <span className="summary-value available">{stats.reduce((sum, s) => sum + s.availableSlots, 0)}</span>
        </div>
      </div>
    </div>
  );
}

export default ServerStats;
